// selecionando geolocalização atual do usuario
import geolocation from '@/helpers/geolocation'

export default {
  'agenda.location.id' (value) {
    if (value === 'current') {
      geolocation(this.setLocationByGeoLocation)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/watch.js